export interface Transaction {
  id: string;
  date: string;
  category: string;
  description: string;
  amount: number;
  type: 'income' | 'expense';
  status: 'cleared' | 'pending';
}

export interface KPI {
  label: string;
  value: string;
  change: number;
  trend: 'up' | 'down';
  icon: string;
}

export interface SpendingCategory {
  name: string;
  value: number;
  percentage: number;
  color: string;
}

export interface MonthlyData {
  month: string;
  income: number;
  expenses: number;
}

export interface Alert {
  id: string;
  type: 'warning' | 'success' | 'info';
  message: string;
  icon: string;
}

// Mock Data
export const mockKPIs: KPI[] = [
  {
    label: 'Total Income',
    value: '$3,500',
    change: 8.2,
    trend: 'up',
    icon: '💵'
  },
  {
    label: 'Total Expenses',
    value: '$2,750',
    change: -3.1,
    trend: 'down',
    icon: '🧾'
  },
  {
    label: 'Savings',
    value: '$750',
    change: 15.7,
    trend: 'up',
    icon: '💰'
  },
  {
    label: 'Overspending Risk',
    value: '32%',
    change: -5.2,
    trend: 'down',
    icon: '⚠️'
  }
];

export const mockSpendingData: SpendingCategory[] = [
  { name: 'Housing', value: 1200, percentage: 43.6, color: '#2563EB' },
  { name: 'Food', value: 450, percentage: 16.4, color: '#22C55E' },
  { name: 'Transportation', value: 380, percentage: 13.8, color: '#F97316' },
  { name: 'Entertainment', value: 320, percentage: 11.6, color: '#EF4444' },
  { name: 'Healthcare', value: 250, percentage: 9.1, color: '#8B5CF6' },
  { name: 'Other', value: 150, percentage: 5.5, color: '#6B7280' }
];

export const mockMonthlyData: MonthlyData[] = [
  { month: 'Jan', income: 3200, expenses: 2800 },
  { month: 'Feb', income: 3350, expenses: 2650 },
  { month: 'Mar', income: 3400, expenses: 2900 },
  { month: 'Apr', income: 3300, expenses: 2700 },
  { month: 'May', income: 3600, expenses: 2850 },
  { month: 'Jun', income: 3500, expenses: 2750 }
];

export const mockTransactions: Transaction[] = [
  {
    id: '1',
    date: '2024-01-15',
    category: 'Food',
    description: 'Whole Foods Market',
    amount: -89.42,
    type: 'expense',
    status: 'cleared'
  },
  {
    id: '2',
    date: '2024-01-15',
    category: 'Income',
    description: 'Salary Deposit',
    amount: 3500.00,
    type: 'income',
    status: 'cleared'
  },
  {
    id: '3',
    date: '2024-01-14',
    category: 'Transportation',
    description: 'Uber Ride',
    amount: -28.50,
    type: 'expense',
    status: 'pending'
  },
  {
    id: '4',
    date: '2024-01-14',
    category: 'Entertainment',
    description: 'Netflix Subscription',
    amount: -15.99,
    type: 'expense',
    status: 'cleared'
  },
  {
    id: '5',
    date: '2024-01-13',
    category: 'Healthcare',
    description: 'CVS Pharmacy',
    amount: -42.18,
    type: 'expense',
    status: 'cleared'
  },
  {
    id: '6',
    date: '2024-01-12',
    category: 'Housing',
    description: 'Rent Payment',
    amount: -1200.00,
    type: 'expense',
    status: 'cleared'
  },
  {
    id: '7',
    date: '2024-01-12',
    category: 'Food',
    description: 'Starbucks',
    amount: -6.75,
    type: 'expense',
    status: 'cleared'
  },
  {
    id: '8',
    date: '2024-01-11',
    category: 'Transportation',
    description: 'Gas Station',
    amount: -45.20,
    type: 'expense',
    status: 'cleared'
  }
];

export const mockAlerts: Alert[] = [
  {
    id: '1',
    type: 'warning',
    message: "You're on track to overspend in Dining by $120 this month.",
    icon: '⚠️'
  },
  {
    id: '2',
    type: 'success',
    message: 'You saved 10% more than last month.',
    icon: '✅'
  },
  {
    id: '3',
    type: 'info',
    message: 'Rent is due in 3 days.',
    icon: '📌'
  },
  {
    id: '4',
    type: 'warning',
    message: 'Unusual spending pattern detected in Entertainment category.',
    icon: '🎭'
  }
];

export const mockAdminData = {
  usersOnboarded: [
    { week: 'W1', users: 45 },
    { week: 'W2', users: 52 },
    { week: 'W3', users: 38 },
    { week: 'W4', users: 61 }
  ],
  subscriptionTiers: [
    { name: 'Free', value: 750, color: '#6B7280' },
    { name: 'Premium', value: 250, color: '#2563EB' }
  ],
  activeUsers: {
    current: 843,
    target: 1000,
    percentage: 84.3
  }
};